import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { ProductModel } from '@core/store/entities/product/product.model';
import { ProductUtils } from '@shared/utils/product.util';

@Component({
  selector: 'nwx-df-blocked-property-card',
  templateUrl: './df-blocked-property-card.component.html',
  styleUrls: ['./df-blocked-property-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DfBlockedPropertyCardComponent implements OnInit {
  @Input() selectedProducts: ProductModel[] = [];

  isCollapsed = false;
  dfIconUrl = 'assets/images/products/dwellingFire/fire_circle.svg';
  propertyProductName = 'Property';

  ngOnInit(): void {
    const propertyProduct = this.selectedProducts.find((p) =>
      ['Homeowner', 'Condominium', 'Tenant'].includes(p.type)
    );

    if (propertyProduct) {
      this.propertyProductName = ProductUtils.getNameForProduct(
        propertyProduct.type
      );
    }
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
  }
}
